<template>
  <b-row no-gutters>
    <b-col>
      <highcharts :key="hcKey" :options="chartOptions" ref="sustainabiltyPieChart"></highcharts>
    </b-col>
  </b-row>
</template>
<script>
import { setChartMenuItemsLang } from '../../utils/formatter'

export default {
  components: {},
  props: {
    value: {
      type: Array,
      required: true,
    },
    callback: {
      type: Function,
      default: (value) => value,
    },
    width: {
      type: [Number, String],
      default: null,
    },
    height: {
      type: [Number, String],
      default: null,
    },
    xyPosition: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      hcKey: 0,
    }
  },
  computed: {
    chartOptions() {
      const vue = this
      return {
        lang: this.setOptions,
        chart: {
          type: 'pie',
          width: vue.width,
          height: vue.height,
          backgroundColor: 'transparent',
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return vue.callback(this.key, this.y, this.color)
          },
        },
        plotOptions: {
          pie: {
            showInLegend: false,
            shadow: false,
            dataLabels: {
              enabled: false,
            },
            center: vue.xyPosition,
          },
        },
        series: vue.value,
      }
    },
    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },
  },
}
</script>
